export default __webpack_public_path__ + "static/media/default-monster.87d14f56.svg";